import React from "react";
import { NavLink } from "react-router-dom";

const Sidebar = ({ addSideClass }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  let role = userData?.data?.role_id;

  return (
    <>
      <div
        className={`sidebar position-fixed  top-0  start-0   h-100  z-2 d-none d-lg-flex  d-xl-flex  d-md-flex ${addSideClass} pt-4`}
      >
        <ul className=" d-none d-lg-flex  d-xl-flex  d-md-flex flex-column   mb-0 ps-0  h-100 pt-5 w-100">
          <li className="mb-1 p-2 w-100">
            <NavLink to="/" className="text-white w-100">
              <i className="fa-solid fa-house"></i>
              <span>Dashboard</span>
            </NavLink>
          </li>

          <li className="mb-1 p-2 w-100">
            <NavLink to="/addlead" className="text-white w-100">
              <i className="fa-solid fa-circle-plus "></i>
              <span>Create Lead</span>
            </NavLink>
          </li>
          <li className="mb-1 p-2 w-100">
            <NavLink to="/managelead" className="text-white  w-100">
              <i className="fa-solid fa-folder"></i>
              <span>Manage Lead</span>
            </NavLink>
          </li>
          <li className="mb-1 p-2">
            <NavLink to="/followup" className="text-white w-100">
              <i className="fa-solid fa-list"></i>
              <span>Follow Up</span>
            </NavLink>
          </li>
          <li className="mb-1 p-2">
            <NavLink to="/not-interested-lead" className="text-white w-100">
              <i className="fa-solid fa-times"></i>
              <span>Not Interested Lead</span>
            </NavLink>
          </li>
          <li className="mb-1 p-2">
            <NavLink to="/dead-lead" className="text-white w-100">
              <i className="fa-solid fa-times-circle"></i>
              <span>Dead Lead</span>
            </NavLink>
          </li>
          <li className="mb-1 p-2">
            <NavLink to="/calender" className=" text-white w-100">
              <i className="fa-solid fa-calendar"></i>
              <span>Calender</span>
            </NavLink>
          </li>
          {/* {
              role === 3 && (
            <li className="mb-1 p-2">
              <NavLink to="/team" className=" text-white w-100">
              <i class="fa-solid fa-users"></i>
                <span>Team</span>
              </NavLink>
            </li>
                
              )
            } */}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
